export default {
  sreenSection: {
    title: {
      fr: "",
      en: "",
    },
    subtitle: {
      fr: "",
      en: "",
    },
    screens: {
      energyDashboard: {
        title: {
          fr: "",
          en: "",
        },
        subtitle: {
          fr: "",
          en: "",
        },
        description1: {
          fr: "Suivi des performances énergétiques",
          en: "Energy performance monitoring",
        },
        description2: {
          fr: "Pilotage centralisé de l'énergie",
          en: "Centralized energy management",
        },
      },
      dju: {
        title: {
          fr: "Consommation du chauffage",
          en: "Heating consumption",
        },
        subtitle: {
          fr: "en fonction du Degré Jour Unifié (DJU)",
          en: "based on Heating Degree Days (HDD)",
        },
        description1: {
          fr: "<strong>Analysez</strong> au pas de temps horaire, journalier, mensuel et annuel.",
          en: "Analyze data at hourly, daily, monthly and yearly intervals.",
        },
        description2: {
          fr: "",
          en: "",
        },
      },
      automatismes: {
        title: {
          fr: "Déployez des automatismes groupés",
          en: "Deploy grouped automations",
        },
        subtitle: {
          fr: "sur l’ensemble de votre parc.",
          en: "Across your entire portfolio.",
        },
        description1: {
          fr: "<strong>Analysez</strong> au pas de temps horaire, journalier, mensuel et annuel.",
          en: "Analyze data at hourly, daily, monthly and yearly intervals.",
        },
        example: {
          one: {
            fr: "21° à 7h30",
            en: "21° at 7:30am",
          },
          two: {
            fr: "17° à 18h00",
            en: "17° at 6pm",
          },
          three: {
            fr: "Coupure à 18h00",
            en: "Off at 6pm",
          },
          four: {
            fr: "Extérieur au coucher du soleil",
            en: "Exterior ON at sunset",
          },
        },
      },
      notifications: {
        title: {
          fr: "Créez des notifications ciblées",
          en: "Create targeted notifications",
        },
        subtitle: {
          fr: "et identifiez les pannes.",
          en: "and quickly identify faults.",
        },
      },
      history: {
        title: {
          fr: "Accédez aux données historiques en temps réel",
          en: "Access real-time historical insights",
        },
        subtitle: {
          fr: "sur l’ensemble de vos équipements et de leurs paramètres.",
          en: "across all equipment and settings.",
        },
      },
    },
  },
};
